/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class EmptyState extends React.Component {
    render() {
        return (
            <div className="socials-empty">
                {this.props.message}
            </div>
        );
    }

};

EmptyState.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    iconClass: PropTypes.string
};

EmptyState.defaultProps = {
    message: '',
    iconClass: 'fa fa-frown-o'
};

export default EmptyState;
